// extracted by mini-css-extract-plugin
export var p = "style-module--p--94f42";